module.exports = __webpack_public_path__ + "img/Check.66197d73.svg";